import { useElementVisibility, type UseElementVisibilityReturn } from '@vueuse/core';
import type { TemplateRef } from 'vue';
import type { ArticleBeacons } from '~~/models/AisSearch/Result';

export const usePlacementBeacon = () => {
  const placementBeaconString = useState<string>(
    'placementBeaconString',
    () => ''
  );

  return {
    placementBeaconString,
  };
};

export const useCriteoBeacons = (element: TemplateRef<HTMLElement>, beacons: Partial<ArticleBeacons>) => {
    const elementIsVisible: UseElementVisibilityReturn = useElementVisibility(element);

    if (beacons?.loadBeacon) {
        sendCriteoBeacon(beacons.loadBeacon);
    }
    watch(
        elementIsVisible,
        (visibility: boolean) => {
            if (visibility && beacons?.viewBeacon) {
                sendCriteoBeacon(beacons?.viewBeacon);
            }
        },
        {
            once: true,
        },
    );
};

export const sendCriteoBeacon = (beacon: string | undefined): void => {
    if (beacon) {
        new Image().src = beacon;
    }
}